import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/app/apps/web/src/components/common/client-only.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadMoreNewsSection"] */ "/app/apps/web/src/components/news/loadmore-news-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/news/NewsSlider/NewsSliderItem.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/app/packages/ui/components/aspect-ratio/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/button/clickable-div.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/button/gradient-button.module.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/carousel/carousel-arrow.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/packages/ui/components/responsive/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/icons/icomoon.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-bronze.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-gold.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/store-revamp/star-silver.webp");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/add_club_coin_icon.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/public/assets/images/subscription/club_coin_icon.webp");
